import { useEffect, useRef } from "react";

export default function NaverMapPicker({
  value,
  onChange,
}) {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const onChangeRef = useRef(onChange);
  const valueRef = useRef(value);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  // 네이버 지도 최초 생성
  useEffect(() => {
    if (!window.naver) return;

    const init = valueRef.current;

    if (!init?.lat || !init?.lng) return;
    if (mapInstance.current) return;

    const center = new window.naver.maps.LatLng(
      init.lat,
      init.lng
    );

    const map = new window.naver.maps.Map(
      mapRef.current,
      {
        center,
        zoom: 18,
      }
    );

    const marker = new window.naver.maps.Marker({
      position: center,
      map,
    });

    mapInstance.current = map;
    markerRef.current = marker;

    // 네이버 지도 클릭시 좌표를 반환하고, 지도 중심으로 이동
    window.naver.maps.Event.addListener(
      map,
      "click",
      (e) => {
        const pos = {
          lat: e.coord.y,
          lng: e.coord.x,
        };

        const latLng =
          new window.naver.maps.LatLng(
            pos.lat,
            pos.lng
          );

        marker.setPosition(latLng);
        map.setCenter(latLng);

        onChangeRef.current?.(pos);
      }
    );
  }, []);

  // 외부 값이 변경되면 마커 위치를 변경하고, 지도 중심으로 이동
  useEffect(() => {
    if (!mapInstance.current) return;
    if (!markerRef.current) return;

    const v = valueRef.current;

    if (!v?.lat || !v?.lng) return;

    const pos = new window.naver.maps.LatLng(
      v.lat,
      v.lng
    );

    markerRef.current.setPosition(pos);
    mapInstance.current.panTo(pos);
  }, [value?.lat, value?.lng]);

  return (
    <div
      ref={mapRef}
      style={{
        width: "100%",
        height: 600,
      }}
    />
  );
}
